import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiResultModel, getDocumentsFromApi } from "@tecumseh/Services/DocumentsSearchService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    query?: string;
    onError?: (errorMessage: string) => void;
}

type HandlerType = CustomApiHandler<Parameter, ApiResultModel>;

export const StartLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/SearchResults/StartFetchingDocuments",
    });
};

export const GetDocuments: HandlerType = async props => {
    if (props.parameter.query) {
        try {
            const result = await getDocumentsFromApi({ search: props.parameter.query });
            props.dispatch({
                type: "Custom/SearchResults/SetDocuments",
                documents: result.documentCollection,
            });
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.apiResult.errorMessage = error.errorJson.message;
                return;
            }
            throw error;
        }
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult?.errorMessage) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const UpdateDocumentsQuery: HandlerType = props => {
    if (props.parameter.query) {
        props.dispatch({
            type: "Custom/SearchResults/UpdateDocumentsQuery",
            query: props.parameter.query,
        });
    }
};

export const chain = [UpdateDocumentsQuery, StartLoading, GetDocuments, ExecuteOnErrorCallback];

const searchDocuments = createHandlerChainRunner(chain, "searchDocuments");
export default searchDocuments;
